import React from 'react';

const LiveBets = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("circle", { cx: "16", cy: "16", r: "13.5", stroke: "#00FFFF" }),
  /* @__PURE__ */ React.createElement("circle", { cx: "16", cy: "16", r: "5.5", fill: "#00FFFF", stroke: "#00FFFF" })
);

export { LiveBets };
//# sourceMappingURL=LiveBets.js.map
